import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Redirect, Route } from "react-router-dom";
import styled from "styled-components";

import Footer from "./components/Footer";
import Mapper from "./Mapper";
import Menu from "./components/Menu";
import PageHead from "./components/PageHead";

const Wrapper = styled.div`
  width: 100%;
  margin-top: 64px;
  @media (max-width: 700px) {
    margin-top: 63px;
  }
`;

class App extends Component<Props, State> {
  render() {
    return (
      <Router>
        <Wrapper className="App">
          <PageHead />
          <Switch>
            <Route exact path='/' component={Mapper} />
            <Redirect from="/home" to="/" />
            <Route path='/:page' component={Mapper} />
            <Route component={Mapper} />
          </Switch>
          <Footer />
          <Menu />
        </Wrapper>
      </Router>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js